import { render, staticRenderFns } from "./ResponseCard.vue?vue&type=template&id=13ae19c9&scoped=true"
import script from "./ResponseCard.vue?vue&type=script&lang=js"
export * from "./ResponseCard.vue?vue&type=script&lang=js"
import style0 from "./ResponseCard.vue?vue&type=style&index=0&id=13ae19c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae19c9",
  null
  
)

export default component.exports